import { appBrandText } from './brand';
import { FORMATIONS_URL, PUBLIC_PATH } from './publicPaths';
import { SITE_BRAND } from './site';
import { CALCUL_BASE_PATH } from '../features/calcul/calculConstants';
import { EXAM_BASE_PATH } from '../features/examens/examChamberConstants';

export const PUBLIC_LEGAL_LINKS = Object.freeze([
  { label: 'Mentions légales', to: PUBLIC_PATH.LEGAL_MENTIONS },
  { label: 'Confidentialité', to: PUBLIC_PATH.PRIVACY },
  { label: 'CGU', to: PUBLIC_PATH.TERMS_OF_SERVICE },
  { label: 'CGV', to: PUBLIC_PATH.TERMS_OF_SALE },
]);

export const PUBLIC_TOOL_LINKS = Object.freeze([
  { label: 'Calcul mental', to: CALCUL_BASE_PATH },
  { label: 'Sujets brevet et bac', to: EXAM_BASE_PATH },
  { label: 'Formations', to: FORMATIONS_URL, external: true },
]);

export const PUBLIC_FOOTER = Object.freeze({
  app: 'PROF',
  home: PUBLIC_PATH.HOME,
  label: SITE_BRAND,
  description: 'Outils et ressources pour apprendre et enseigner.',
  navigationLabel: 'Ressources',
  links: [...PUBLIC_TOOL_LINKS, { label: 'Avance Immédiate', to: PUBLIC_PATH.AVANCE }],
  legalLabel: 'Informations légales et contact',
  legalLinks: [{ label: 'Contact', to: PUBLIC_PATH.CONTACT }, ...PUBLIC_LEGAL_LINKS],
});

export const CALCUL_FOOTER = Object.freeze({
  ...PUBLIC_FOOTER,
  app: 'CALCUL',
  home: CALCUL_BASE_PATH,
  label: appBrandText('CALCUL'),
  description: 'S’entraîner, apprendre, progresser.',
  links: PUBLIC_TOOL_LINKS.filter(({ to }) => to !== CALCUL_BASE_PATH),
});

export const EXAM_FOOTER = Object.freeze({
  ...CALCUL_FOOTER,
  app: 'EXAM',
  home: EXAM_BASE_PATH,
  label: appBrandText('EXAM'),
  links: PUBLIC_TOOL_LINKS.filter(({ to }) => to !== EXAM_BASE_PATH),
});
